import { Button, Stack } from "@mui/material";
import { filters } from "../../utils/filters";
import Filter from "src/components/TableFilter";
import { useClearFilters } from "src/hooks/useClearFilter";
import {
  LIMIT,
  ORDER,
  ORDER_BY,
  PAGE,
  QUEUE_TYPE,
} from "src/constants/searchParams";

const WaitingRoomTrackerFilters = () => {
  const clearAll = useClearFilters([PAGE, LIMIT, QUEUE_TYPE, ORDER, ORDER_BY]);

  return (
    <Stack direction="row" gap={2}>
      <Stack direction={"row"} gap={2} flexWrap={"wrap"}>
        {filters.map((filter) => (
          <Filter current={filter} key={filter.name} />
        ))}
        <Stack direction="row" gap={2}>
          <Button onClick={clearAll}>Clear all</Button>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default WaitingRoomTrackerFilters;
